import React from 'react';
import { legalInfo } from '../utils/legal';

const PrivacyPolicy: React.FC = () => {
  const name = legalInfo.tradingName || legalInfo.legalName;
  return (
    <div className="max-w-3xl mx-auto px-4 py-8 text-left">
      <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
      <p className="text-gray-700 mb-6">Last updated: {new Date().getFullYear()}</p>

      <p className="mb-4">This policy explains how {name} ("we", "us") collects, uses, and protects your personal data in accordance with UK GDPR and the Data Protection Act 2018.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Controller</h2>
      <p className="mb-4">Data controller: {legalInfo.legalName}. Contact: {legalInfo.dataProtectionEmail || legalInfo.publicEmail || 'add email'}; Address: {legalInfo.registeredOfficeAddress || 'add address'}.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">What we collect</h2>
      <p className="mb-2">We collect minimal personal data to operate the website and fulfill in‑store orders:</p>
      <ul className="list-disc ml-6 space-y-2 mb-4">
        <li><strong>Order details (no personal data):</strong> Items ordered, quantities, and totals for preparing your order. Online card payments are disabled; we do not collect payment card details.</li>
        <li><strong>Contact form (optional):</strong> Your name, email address, and message if you use our contact form. Used only to respond to your enquiry.</li>
        <li><strong>Shopping cart:</strong> Stored in your browser's local storage so your cart persists if you close the page.</li>
        <li><strong>Technical data:</strong> Basic usage/diagnostic data via Firebase (e.g. device/browser) to keep the site running and improve performance.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">What we do NOT do</h2>
      <ul className="list-disc ml-6 space-y-2 mb-4">
        <li>No customer accounts or sign‑ups.</li>
        <li>No online card payments; no collection of card details.</li>
        <li>No marketing mailing lists or promotional emails.</li>
        <li>No third‑party advertising, profiling, or automated decision‑making.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">Cookies and Local Storage</h2>
      <p className="mb-2">Our website uses the following:</p>
      <ul className="list-disc ml-6 space-y-2 mb-4">
        <li><strong>Essential:</strong> Shopping cart data (localStorage) - stores your selected items.</li>
        <li><strong>Essential:</strong> Order session data (sessionStorage) - temporarily stores order details during your visit.</li>
        <li><strong>Essential:</strong> Cookie consent preferences (localStorage) - remembers your cookie choices.</li>
        <li><strong>Analytics:</strong> Firebase/Google analytics may track page views and site usage to help us improve.</li>
        <li><strong>Performance:</strong> Asset cache (localStorage) - ensures you see the latest version of our site.</li>
      </ul>
      <p className="mb-4">You can manage cookie preferences through your browser settings or our cookie consent banner.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Why we use your data</h2>
      <ul className="list-disc ml-6 space-y-2">
        <li>To process and fulfill your orders for collection (no online card payment).</li>
        <li>To respond to enquiries sent via our contact form.</li>
        <li>To improve our website and services through analytics.</li>
        <li>To maintain security and prevent fraud.</li>
        <li>To comply with legal and tax obligations.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">Legal bases</h2>
      <p className="mb-4">We rely on contract (processing orders), legitimate interests (analytics, security, site operation), and legal obligation (tax records). For analytics cookies, we rely on consent via our cookie banner.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Third-party services</h2>
      <p className="mb-2">We use the following trusted third-party services:</p>
      <ul className="list-disc ml-6 space-y-2 mb-4">
        <li><strong>Firebase/Google Cloud:</strong> Hosting, database, and optional analytics. See <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer" className="text-red-600 hover:underline">Firebase Privacy Policy</a>.</li>
        <li><strong>Email (contact form only):</strong> Email to our team is delivered via Google (Gmail). See <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-red-600 hover:underline">Google Privacy Policy</a>.</li>
      </ul>
      <p className="mb-4">We do not sell your personal data to third parties.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">International transfers</h2>
      <p className="mb-4">If data is transferred outside the UK, we use approved safeguards (e.g. IDTA/SCCs).</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Data retention</h2>
      <p className="mb-4">We keep data only as long as necessary, for example, order records retained for tax/financial purposes.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Your rights</h2>
      <ul className="list-disc ml-6 space-y-2">
        <li>Access, rectification, erasure, restriction, objection, portability.</li>
        <li>Withdraw consent where processing is based on consent.</li>
        <li>If you have any complaint, you can complain to the ICO at ico.org.uk.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">Contact</h2>
      <p>Email: {legalInfo.dataProtectionEmail || legalInfo.publicEmail || 'add email'} | Address: {legalInfo.registeredOfficeAddress || 'add address'}</p>
    </div>
  );
};

export default PrivacyPolicy;



